import React from 'react'

const GameControllerIcon = ({ size = 24, className = '', style = {} }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={style}
    >
      <defs>
        <linearGradient id="gameControllerGradient" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="rgba(150, 100, 255, 1)" />
          <stop offset="100%" stopColor="rgba(100, 150, 255, 1)" />
        </linearGradient>
        <filter id="gameControllerGlow">
          <feGaussianBlur stdDeviation="2" result="coloredBlur"/>
          <feMerge>
            <feMergeNode in="coloredBlur"/>
            <feMergeNode in="SourceGraphic"/>
          </feMerge>
        </filter>
      </defs>
      
      {/* Controller body */}
      <path
        d="M7 10 C4 10 3 12 3 14 C3 16 4 18 7 18 L9 18 L9 14 L15 14 L15 18 L17 18 C20 18 21 16 21 14 C21 12 20 10 17 10 L7 10 Z"
        stroke="url(#gameControllerGradient)"
        strokeWidth="2"
        fill="rgba(150, 100, 255, 0.2)"
        filter="url(#gameControllerGlow)"
      />
      
      {/* D-pad left */}
      <line x1="5" y1="14" x2="7" y2="14" stroke="url(#gameControllerGradient)" strokeWidth="1.5" />
      
      {/* D-pad up */}
      <line x1="6" y1="13" x2="6" y2="15" stroke="url(#gameControllerGradient)" strokeWidth="1.5" />
      
      {/* Action buttons */}
      <circle cx="17" cy="12" r="1" fill="rgba(255, 100, 200, 1)" />
      <circle cx="19" cy="14" r="1" fill="rgba(100, 200, 255, 1)" />
      
      {/* Grips */}
      <path
        d="M9 18 Q9 20 10 21"
        stroke="url(#gameControllerGradient)"
        strokeWidth="1.5"
        fill="none"
      />
      <path
        d="M15 18 Q15 20 14 21"
        stroke="url(#gameControllerGradient)"
        strokeWidth="1.5"
        fill="none"
      />
    </svg>
  )
}

export default GameControllerIcon
